module.exports = __webpack_public_path__ + "static/media/icon_file_dll.2095d148.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_dll.svg
// module id = 152
// module chunks = 0